import { User } from "oidc-client-ts";
import { createContext, useContext } from "react";

interface AuthContextType {
  user: User | null;
  isAuthenticated: boolean;
  logout: () => Promise<void>;
  login: (returnUrl: string) => Promise<void>;
  completeLogin: () => Promise<string>;
}

export const AuthContext = createContext<AuthContextType | null>(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
